export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11379.f842dfc2.jpg";